import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Switch as AntSwitch } from "antd";
import "./Switch.scss";
const CSS_PREFIX = `lav-components-switch`;
export const Switch = (_a) => {
    var { className = "" } = _a, antSwitchProps = __rest(_a, ["className"]);
    return (_jsx(AntSwitch, Object.assign({}, antSwitchProps, { className: classNames(`${className} ${CSS_PREFIX}`, {
            [className]: !!className,
        }) })));
};
